import "htmx.org";
import { destroy, mount } from "./lifecycle";
import "./styles/base.css";

interface HtmxSwapEvent extends Event {
  detail?: { target?: Element };
}

function focusAfterSwap(target?: Element): void {
  if (!target) return;

  if (target.id === "document-shell") {
    document.querySelector<HTMLElement>("#main-content")?.focus({
      preventScroll: true
    });
    return;
  }

  if (target.id === "inquiry-region") {
    const result =
      target.querySelector<HTMLElement>(".form-summary") ??
      target.querySelector<HTMLElement>(".inquiry-success") ??
      target.querySelector<HTMLElement>("[aria-invalid='true']");
    result?.focus({ preventScroll: true });
  }
}

function start(): void {
  mount(document);

  document.body.addEventListener("htmx:beforeSwap", () => {
    destroy();
  });

  document.body.addEventListener("htmx:afterSwap", (event) => {
    const target = (event as HtmxSwapEvent).detail?.target;
    mount(document);
    focusAfterSwap(target);
  });

  document.body.addEventListener("htmx:historyRestore", () => {
    mount(document);
  });

  registerServiceWorker();
}

async function registerServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register("/wallpaperdemo/sw.js", {
      scope: "/wallpaperdemo/"
    });

    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    registration.addEventListener("updatefound", () => {
      const worker = registration.installing;
      worker?.addEventListener("statechange", () => {
        if (worker.state === "installed" && navigator.serviceWorker.controller) {
          worker.postMessage({ type: "SKIP_WAITING" });
        }
      });
    });
  } catch (error) {
    const status = document.querySelector<HTMLElement>("#app-status");
    if (status) {
      status.textContent =
        "Offline support could not be installed in this browser session.";
    }
    console.error("Service worker registration failed", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start, { once: true });
} else {
  start();
}
